module.exports = __webpack_public_path__ + "static/media/logo.c05c2f0d.svg";